import { DashboardColumnValueAggregator } from "src/app/dashboards/shared/interfaces/DashboardColumnValueAggregator";

export function groupData(
  records: any[],
  filterValues: Map<string, any>,
  config: {
    groupingKey: string | string[];
    aggregators: Map<string, DashboardColumnValueAggregator>;
    keepItemsAs?: string | null; // null means do not keep the items
  }
): any[] {
  const { groupingKey, aggregators, keepItemsAs = null } = config;

  const groupedRecords = new Map<string, any>();

  for (const originalRecord of records) {
    // Clone the record to prevent mutation of the original
    const record = { ...originalRecord };

    const groupedRecordKey: string = Array.isArray(groupingKey)
      ? groupingKey.map((key) => record[key]).join('-')
      : record[groupingKey];

    if (!groupedRecordKey) continue;

    if (groupedRecords.has(groupedRecordKey)) {
      const existingRecord = groupedRecords.get(groupedRecordKey);

      for (const [column, aggregator] of Array.from(aggregators.entries())) {
        const aggregatedValue = aggregator({
          acc: existingRecord[column],
          val: record[column],
          row: existingRecord,
          filterValues,
        });
        existingRecord[column] = aggregatedValue.toString();
      }

      if (keepItemsAs) {
        // Ensure originalRecord is used to keep the original data intact
        existingRecord[keepItemsAs].push({ ...originalRecord });
      }

      groupedRecords.set(groupedRecordKey, existingRecord);
    } else {
      const newRecord = { ...record };

      if (keepItemsAs) {
        // Ensure originalRecord is used to initialize the array
        newRecord[keepItemsAs] = [{ ...originalRecord }];
      }

      groupedRecords.set(groupedRecordKey, newRecord);
    }
  }

  // Convert the grouped records map to an array
  return Array.from(groupedRecords.values());
}